
<!-- Modal -->
<div class="modal-header">
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
      <span aria-hidden="true">&times;</span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
      <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
      [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
  </button>
  </div>
  <div class="modal-body">
  
    <div class="messages">
      <div *ngIf="xmlsToSign.length > 0 && xmlsToSign[0] && !noData"> {{ 'EDS.DOCUMENT_IS_READY_FOR_SIGNATURE' | translate }} </div>
      
      <div *ngIf="xmlsToSign.length > 0 && !xmlsToSign[0] && !noData"> {{ 'EDS.GETTING_DOCUMENT' | translate }} </div>
      
      <div *ngIf="(xmlsToSign.length == 0 || (xmlsToSign.length > 0 && !xmlsToSign[0])) && noData"> {{ 'EDS.DOCUMENT_NOT_RECEIVED' | translate }} </div>
    </div> 
  
    <!--временная реализация...-->
    <div *ngIf="xmlsToSign.length > 0">
      <form class="form" [formGroup]="profileForm" autocomplete="off">
        <div>
          <input formControlName="storageSelect" id="storageSelect" type="hidden" value="PKCS12">
          <div formArrayName="xmlsToSign">
            <div *ngFor="let xmlToSign of profileForm.get('xmlsToSign')['controls']; let i = index;">
              <div [formGroupName]="i">
                  <input formControlName="value" class="xmlToSign" name="xmlToSign[]" type="hidden">
              </div>
            </div>
          </div>
          <div formArrayName="signedXmls">
            <div *ngFor="let signedXml of profileForm.get('signedXmls')['controls']; let j = index;">
              <div [formGroupName]="j">
                  <input formControlName="value" class="signedXml" name="signedXml[]" type="hidden" (click)="sendSignedXml($event.target.value)"> <!-- onclick="$('.close').click()" -->
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!--------->
  
  </div>
  <div class="modal-footer btn-box">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss(false)">{{ 'CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary btn-sm" onclick="signXmlsCall();" [disabled]="xmlsToSign.length == 0">{{ 'EDS.SIGN' | translate }}</button>
  </div>